import { getHomePageUrl } from 'utils/navigation';

export const licenseBreadcrumbs = (): any => [
  {
    href: getHomePageUrl(),
    label: 'Начало',
  }
];
